/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalState } from "../types";

const initialState: ModalState = { login: false, signup: false, forget: false };

export const modalSlice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        setLoginModal: (state, action: PayloadAction<boolean>) => {
            state.login = action.payload;
            state.signup = false;
            state.forget = false;
        },

        setSignupModal: (state, action: PayloadAction<boolean>) => {
            state.login = false;
            state.signup = action.payload;
            state.forget = false;
        },

        setForgetModal: (state, action: PayloadAction<boolean>) => {
            state.login = false;
            state.signup = false;
            state.forget = action.payload;
        },
    },
});

// Actions
export const {
    setLoginModal,
    setSignupModal,
    setForgetModal,
} = modalSlice.actions;

export default modalSlice.reducer;
